import { IPublicClientApplication } from '@azure/msal-browser';
import {
  OperationName,
  OperationStatus,
  OperationStatusType,
} from '../../models';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import {
  getOperationStatus,
  getProgramEnrolmentSyncSummary,
  initiateOperation,
  streamOperationStatus,
} from './index';

export const createOperationsApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  initiateOperation: (instance: IPublicClientApplication, operationName: OperationName) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => initiateOperation(fetchContext, operationName, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('initiateOperation', isInFlight);
    },
  ),
  getOperationStatus: (instance: IPublicClientApplication, operationName: OperationName, operationStatus?: OperationStatusType) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getOperationStatus(fetchContext, operationName, operationStatus, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getOperationStatus', isInFlight);
    },
  ),
  streamOperationStatus: (instance: IPublicClientApplication, operationName: OperationName, onStatus: (status: OperationStatus) => void, signal?: AbortSignal) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => streamOperationStatus(fetchContext, operationName, onStatus, accessToken, signal),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('streamOperationStatus', isInFlight);
    },
  ),
  getProgramEnrolmentSyncSummary: (instance: IPublicClientApplication) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getProgramEnrolmentSyncSummary(fetchContext, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getProgramEnrolmentSyncSummary', isInFlight);
    },
  ),
});
